import { Typography } from "@mui/material";
import React, { useState } from "react";
import styles from "./FaqAccordion.module.css";
import plus_icon from "assets/images/plus.svg";
import minus_icon from "assets/images/minus.svg";

function FaqAccordion({index, question, answer }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`${styles.accordion} ${open && styles.accordion_b_top} ${index === 0 && styles.accordion_b_top} `}>
      <div
        onClick={() => {
          setOpen(!open);
        }}
        className={styles.heading}
      >
        <Typography variant="h6">{question}</Typography>
        {open ? (
          <img src={minus_icon} alt="" />
        ) : (
          <img src={plus_icon} alt="" />
        )}
      </div>
      {open && (
        <div className={styles.body}>
            {answer}
        </div>
      )}
    </div>
  );
}

export default FaqAccordion;
